"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _select = _interopRequireDefault(require("../../select"));
var _InputError = _interopRequireDefault(require("../../errors/InputError"));
var _excluded = ["value", "formulaOperators", "formulaChange", "labels", "error"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var StyledOperator = _styledComponents["default"].div.withConfig({
  displayName: "Operator__StyledOperator",
  componentId: "sc-1pd2a7f-0"
})(["", ""], function (props) {
  var typography = props.theme.typography;
  return (0, _styledComponents.css)([".Select-value,.Select-menu-outer{font-size:", ";}"], typography.size.paragraphMedium);
});
StyledOperator.displayName = 'StyledOperator';
var Operator = function Operator(_ref) {
  var value = _ref.value,
    formulaOperators = _ref.formulaOperators,
    formulaChange = _ref.formulaChange,
    labels = _ref.labels,
    error = _ref.error,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledOperator, null, /*#__PURE__*/_react["default"].createElement(_select["default"], _extends({
    value: value,
    onChange: formulaChange,
    required: true,
    options: formulaOperators.map(function (item) {
      return {
        value: item.name,
        label: item.displayName
      };
    }),
    className: "formula-operator ".concat(error ? 'error' : ''),
    backgroundColor: "transparent"
  }, otherProps, {
    searchable: false
  })), error && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    message: labels.RULES_BUILDER_OPERATOR_MISSING
  }));
};
Operator.defaultProps = {
  error: false
};
Operator.propTypes = {
  error: _propTypes["default"].bool,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  value: _propTypes["default"].string.isRequired,
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })).isRequired,
  formulaChange: _propTypes["default"].func.isRequired
};
Operator.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Operator",
  "props": {
    "error": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "value": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "formulaOperators": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "displayName": {
              "name": "string",
              "required": false
            },
            "name": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "formulaChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = Operator;
exports["default"] = _default;